// Contrato do GET /v3/customers/can_create, compartilhado pelo cadastro manual
// (CustomerBodyModal) e pela tela de edição (templates/v2/Data). Os dois consomem
// o mesmo endpoint, que por sua vez espelha Customer#document_unique_per_merchant.
export type ConflictStatus = 'active' | 'archived' | 'blocked' | 'deleted'

export type ConflictRecord = {
  uuid: string
  name: string
  document: string
  status: ConflictStatus
  category?: string
  created_at?: string
}

export type CanCreateResult = {
  canCreate: boolean
  reason: 'duplicate_document' | 'inactive_customer' | null
  allowDuplicate: boolean
  records: ConflictRecord[]
}

export const STATUS_LABEL: Record<ConflictStatus, string> = {
  active: 'Ativo',
  archived: 'Arquivado',
  blocked: 'Bloqueado',
  deleted: 'Excluído'
}

export const INACTIVE_STATUSES: ConflictStatus[] = ['archived', 'deleted']
